import { applyPredicates } from '../utils';
import { unless } from './unless';
import { when } from './when';

export const [whenIsArray, whenIsEmpty, whenIsFunction, whenIsNil, whenIsNumber, whenIsObject, whenIsString] =
    applyPredicates(when);

export const [
    unlessIsArray,
    unlessIsEmpty,
    unlessIsFunction,
    unlessIsNil,
    unlessIsNumber,
    unlessIsObject,
    unlessIsString,
] = applyPredicates(unless);
